import { Grommet } from 'grommet';
import AdminPanel from 'modules/admin/AdminPanel';
import { actions } from 'modules/asset/asset$';
import Forgot from 'modules/auth/components/Forgot';
import Login from 'modules/auth/components/Login';
import Register from 'modules/auth/components/Register';
import Reset from 'modules/auth/components/Reset';
import { authenticate } from 'modules/auth/stream/actions';
import CourseHome from 'modules/course/CourseHome';
import SingleCourse from 'modules/course/SingleCourse';
import { courseActions } from 'modules/course/course$';
import Home from 'modules/home/Home';
import NewsHome from 'modules/news/NewsHome';
import SingleNews from 'modules/news/SingleNews';
import Notification from 'modules/notification/Notification';
import InfoHome from 'modules/page/info/InfoHome';
import JoinUs from 'modules/page/joinUs/JoinUs';
import OffersHome from 'modules/page/offers/OffersHome';
import RentUs from 'modules/page/rentUs/RentUs';
import React, { useEffect } from 'react';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { dispatchAction } from 'rxbeach';
import ErrorBoundary from './ErrorBoundry';
import AppHeader from './components/AppHeader';
import Footer from './components/Footer';
import NotFound from './components/NotFound';
import { theme } from './theme';
import { identify, page } from './tracking';

const Layout = () => (
  <>
    <AppHeader />
    <Outlet />
    <Footer />
  </>
)

const Root = () => {
  useEffect(() => {
    dispatchAction(actions.apiGetItems([]));
    dispatchAction(courseActions.apiGetItems([]));
    dispatchAction(authenticate());

    window.addEventListener('hashchange', () => {
      page();
    });
    identify();
  }, []);

  return (
    <Grommet theme={theme}>
      <BrowserRouter>
        <ErrorBoundary>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/nyheter" element={<NewsHome />} />
              <Route path="/nyheter/:id" element={<SingleNews />} />

              <Route path="/bli-medlem" element={<JoinUs />} />
              <Route path="/leie" element={<RentUs />} />

              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot" element={<Forgot />} />

              <Route path="/kurs/" element={<CourseHome />} />
              <Route path="/kurs/:shortid" element={<SingleCourse />} />

              <Route path="/seiltilbud" element={<OffersHome />} />
              <Route path="/info" element={<InfoHome />} />

              <Route path="/reset" element={<Reset />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/admin/:tab" element={<AdminPanel />} />
              <Route path="/admin/:tab/:id" element={<AdminPanel />} />

              <Route element={<NotFound />} />
            </Route>
          </Routes>
          <Notification />
        </ErrorBoundary>
      </BrowserRouter>
    </Grommet >
  );
};

export default Root;
